import { Row } from 'react-table';
import { ContributionsResponse } from 'services/requests';
import Table from 'components/Table';
import {
  columns,
  ContributionTableSign,
  MapData,
} from '../../ContributionsTable/ContributionsTable.columns';

type Props = {
  contributionsListData?: ContributionsResponse;
  items?: MapData;
  onContributionClick: (row: Row<ContributionTableSign>) => void;
};

const RenderContributionsTable = ({
  contributionsListData,
  items,
  onContributionClick,
}: Props): JSX.Element | null => {
  if (!items || (items && items?.length === 0)) return null;

  return (
    <Table<ContributionTableSign>
      columns={columns}
      data={items}
      onRowClick={onContributionClick}
    />
  );
};

export default RenderContributionsTable;
